import React, { useState, useEffect } from 'react'
import './event_template.css'
import {  create_cal_event } from '../services/events_service'



const downloadIcsFile = (event) => {
    const cal = create_cal_event(event)
    const icsContent = cal.toString();
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'ots_event.ics';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

const dateToDatetime = (d) => {
    return `${d.getYear()}-${d.getMonth()}-${d.getDate()}`
}
 
const dateToTextWithTime = (d) => {
    return `${d.toLocaleDateString("en-US", { weekday: 'long' })} ${d.toLocaleDateString("en-US", { month: 'long' })} ${d.getDate()},
     ${d.toLocaleTimeString("en-US", { timeStyle: 'short' })}`
}

const EventWhat = ({ description }) => <div className="event-details"><b>What:</b> {description}</div>
const EventWhere = ({ location }) => <div className="event-details"><b>Where:</b> {location}</div>
const EventWhen = ({ dateTime, timeText }) => <div className='event-time'><b>When:</b> <time datetime={dateTime}>{timeText}</time></div>

const EventView = ({ otsevent }) => {

    const { start_time, end_time, summary, description, location, url, linktext, image } = otsevent;

    const [dateTime, setDateTime] = useState('')
    const [timeText, setTimeText] = useState('')

    useEffect(() => {
        const start_time_date = new Date(start_time)
        setDateTime(dateToDatetime(start_time_date))
        setTimeText(dateToTextWithTime(start_time_date))
    }, [start_time])

    return (
        <React.Fragment>
            <div className="event-main">
                 {image && (<div className="event-image-container">
                        <img className="event-image" alt={summary && "ots event"} src={image} />
                    </div>)}
                <div className="event-details-container" >
                    {description && <EventWhat description={description} />}
                    {location && <EventWhere location={location} />}
                    {(dateTime && timeText) && <EventWhen dateTime={dateTime} timeText={timeText} />}
                    {url && <div className="event-details">Link: <a href={url}>{linktext ? linktext : url}</a></div>}
                    <div className="event-details add-to-calendar-btn"><span className="btn add-to-calendar-btn" onClick={() => downloadIcsFile(otsevent)}>Add to Calendar</span></div>
                   
                </div>
                
            </div>
        </React.Fragment>
    )
}


export { EventView }